module.exports = __webpack_public_path__ + "static/media/nPayBillsSidebarIcon.9df1c0f8.svg";